/* unplugin-vue-components disabled */import script from "./mg-list-page-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-list-page-layout.vue?vue&type=script&setup=true&lang=js"

import "./mg-list-page-layout.vue?vue&type=style&index=0&id=84619014&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84619014"]])

export default __exports__